import { render, staticRenderFns } from "./FastInput.vue?vue&type=template&id=f536816a&scoped=true"
import script from "./FastInput.vue?vue&type=script&lang=js"
export * from "./FastInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f536816a",
  null
  
)

export default component.exports